import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { loadPartnerVerificationsSummary } from '../actionCreators';
import { getOfferPartnerVerificationsSummary, getVerificationSummaryIsLoaded } from '../selectors';

const OfferPartnerVerificationSummary = React.memo(({ documentId, siteId, partnerId }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const verificationsSummary = useSelector(state => getOfferPartnerVerificationsSummary(state, partnerId), shallowEqual);
  const isSummaryLoaded = useSelector(state => getVerificationSummaryIsLoaded(state, partnerId), shallowEqual);

  useEffect(() => {
    if (!isSummaryLoaded) {
      dispatch(loadPartnerVerificationsSummary(documentId, siteId, partnerId));
    }
  }, [isSummaryLoaded, dispatch, documentId, siteId, partnerId]);

  if (!isSummaryLoaded || !verificationsSummary) {
    return null;
  }

  return (
    <>
      {verificationsSummary.summaryItems?.map((partnerSummary, index) => {
        return (
          <Grid container key={index}>
            <Grid item xs={12} sm={2} md={4}>
              <strong>
                {t('OfferEdit.Client.Verification.Header')} {partnerSummary.partnerName}:
              </strong>{' '}
              <span id={'offerPartnerVerificationCard_summary_' + index + '_entity_count'}>{partnerSummary.totalCount}</span>
            </Grid>
            {partnerSummary.statusCounts?.map((statusCount, i) => {
              return (
                <Grid item xs={12} sm={2} md={2} key={i}>
                  <strong>{statusCount.status}:</strong>{' '}
                  <span id={'offerPartnerVerificationCard_summary_' + index + '_entity_status_' + i}>{statusCount.count}</span>
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </>
  );
});

OfferPartnerVerificationSummary.displayName = 'OfferPartnerVerificationSummary';
OfferPartnerVerificationSummary.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired
};

export default OfferPartnerVerificationSummary;
